import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useNavigate } from "react-router-dom";
import api from "./Axios/api";
import { Eye } from 'lucide-react';
const DeletedPOList = () =>
{
      const [data, setData] = useState([]);
      const [month, setMonth] = useState("");
      const navigation = useNavigate();
      const getData = async () => {
            try {
                const res = await api.get(`/po-detail/get?month=${month}&status=0`);
                const sortedData = res.data.sort((a,b)=>new Date(b.po_date)- new Date(a.po_date));
                return setData(sortedData);
            }
        catch (error) {
            console.log(error);
            }
     };
    
       const branchMapping = {
    "666c0f5ebeca5ab2c65b2c85": "INSULATION",
    "666c0f5ebeca5ab2c65b2c86": "PROJECTS",
    "666c0f5ebeca5ab2c65b2c87": "ROCKFIBRE",
  };
      useEffect(() => {
        getData();
      }, [month]);
   useEffect(() => {
       const now = new Date();
       const year = now.getFullYear();
       const monthNum = String(now.getMonth() + 1).padStart(2, "0");
       const currentMonth = `${year}-${monthNum}`;
       setMonth(currentMonth);
     }, []);
  
    const columns = useMemo(
    () => [
      {
        accessorKey: "po_date",
        header: "Date",
        size: 150,
        Cell: ({ cell }) => new Intl.DateTimeFormat("en-GB").format(new Date (cell.getValue())),
      },
      {
        accessorKey: "po_number",
        header: "PO NO.",
        size: 150,
      },
      {
        accessorKey: "party_name",
        header: "PARTY",
        size: 150,
      },
      {
        accessorKey: "created_by_name",
        header: "Created by",
        size: 150,
      },
      {
        accessorKey: "po_branch",
        header: "PO Branch",
        size: 150,
        Cell: ({ cell }) => {
          const branchId = cell.getValue();
          const branchName = branchMapping[branchId] || "UNKNOWN";

          return <div className="max-h-10 overflow-y-auto">{branchName}</div>;
        },
      },
       {
        accessorKey: "_id",
        header: "Action",
        size: 150,
        Cell :({cell}) =>
        (
           <div
              onClick={() =>
                navigation(`/create-po-form`, {
                  state: { poId: cell.getValue() },
                })
              }
            >
              <button>
                <Eye size={20} />
              </button>
            </div>
        )
      }
    ],
    [month]
  );
    const table = useMaterialReactTable({
      columns,
      data: data,
    });
  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div className="px-2 py-4 rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full px-3 gap-4">
          <div className="text-lg text-violet-500 font-bold">
            Closed / Deleted PO List
          </div>
            <div className="mb-4 space-x-2">
            <input
              type="month"
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
              }}
              className="border rounded px-2 py-1"
            />
          </div>
        </div>
      </div>

      <div className="w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd]">
        <MaterialReactTable table={table} />
      </div>
    </div>
  ); 
}
export default DeletedPOList;
